/**
 * TEMPORARY — company-scoped validation gate for the split-cheque drag-and-drop
 * crash fix (PR #3911).
 *
 * The fix defers dnd drop mutations (and batches multi-item moves) so that
 * react-dnd doesn't unregister a drop target mid-transaction and crash with
 * "Invariant Violation: Expected to find a valid target.". We can't reproduce
 * the crash on our own terminals, so the fix is limited to the affected
 * customer's company id — this lets us validate it in production without
 * changing behaviour for every other company.
 *
 * A non-matching / empty id keeps the original synchronous behaviour for all
 * companies. Once the fix is verified for the customer, remove this gate and
 * always run the deferred/batched path.
 */
export const SPLIT_CHEQUE_CRASH_FIX_COMPANY_IDS: string[] = [
  'cmnt95blwpw2g0c29srsbx8bs', // JPV Gruppen AB
  'cl10pouc9pwah0817u9f9dcci', // 1889 (DEV)
];

/** True when the given company should use the deferred dnd drop crash fix. */
export const isSplitChequeCrashFixCompany = (company?: string | null): boolean =>
  !!company && SPLIT_CHEQUE_CRASH_FIX_COMPANY_IDS.includes(company);

/**
 * Runs a dnd drop mutation. When the fix is enabled for the company we defer it
 * to the next tick, so it runs after react-dnd's drop transaction has finished;
 * otherwise we run it synchronously, exactly as before.
 */
export const runDndDrop = (useFix: boolean, fn: () => void): void => {
  if (useFix) {
    setTimeout(fn, 0);
  } else {
    fn();
  }
};
